module.exports = __webpack_public_path__ + "img/brandspet.05d55af8.jpg";